import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import LoadingScreen from "./components/LoadingScreen";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import TreatmentsPage from "./pages/TreatmentsPage";
import TreatmentDetailPage from "./pages/TreatmentDetailPage";
import ProcedureDetailPage from "./pages/ProcedureDetailPage";
import ConsultationPage from "./pages/ConsultationPage";
import ContactPage from "./pages/ContactPage";
import BeforeAfterPage from "./pages/BeforeAfterPage";
import ScarGuidePage from "./pages/ScarGuidePage";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  const [loading, setLoading] = useState(true);
  const handleLoadingComplete = useCallback(() => setLoading(false), []);

  return (
    <div className="App min-h-screen bg-clinic-bg">
      {loading && <LoadingScreen onComplete={handleLoadingComplete} />}
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/treatments" element={<TreatmentsPage />} />
            <Route path="/treatments/:treatmentId" element={<TreatmentDetailPage />} />
            <Route path="/treatments/:treatmentId/:procedureId" element={<ProcedureDetailPage />} />
            <Route path="/consultation" element={<ConsultationPage />} />
            <Route path="/before-after" element={<BeforeAfterPage />} />
            <Route path="/scar-guide" element={<ScarGuidePage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
